<template>
  <v-dialog v-model="dialogValue" max-width="420">
    <PlanosPagamento
      :dialog="dialogPlanos"
      @dialogClose="dialogClosePlanos"
      :pagamento="pagamento"
      @addPagamento="addPagamento"
    />
    <v-card class="pb-3">
      <v-progress-linear
        v-if="loading"
        indeterminate
        color="primary"
      ></v-progress-linear>
      <v-card-title>
        <v-icon left>mdi-cash-multiple</v-icon>
        Selecionar Pagamentos
        <v-spacer />
        <v-icon @click="dialogClose">close</v-icon>
      </v-card-title>
      <template v-for="(item, j) in pagamentos">
        <v-list-item :key="j" class="ml-3">
          <v-list-item-action>
            <v-row>
              <v-checkbox
                class="pr-3"
                @click="selecionarPlanos(item)"
                v-model="pagamentosVisiveis"
                :value="item.id"
                :label="item.descricao"
              />
              <!-- <v-btn text class="pa-0 ma-0" v-if="item.parcelavel" small>
                Configurar Parcelas
              </v-btn> -->
            </v-row>
          </v-list-item-action>
        </v-list-item>
      </template>
      <v-btn class="ml-7 mr-7 mt-3 mb-3" color="success" @click="salvar()">
        <v-icon left>mdi-content-save</v-icon>
        salvar
      </v-btn>
    </v-card>
  </v-dialog>
</template>

<script>
import PlanosPagamento from "./PlanosPagamento.vue";
export default {
  props: {
    dialog: Boolean,
    id: String,
  },
  components: { PlanosPagamento },
  data: () => ({
    loading: false,
    pagamentos: {},
    pagamentosVisiveis: [],
    dialogPlanos: false,
    pagamento: {},
  }),
  computed: {
    dialogValue: {
      get() {
        return this.dialog;
      },
      set() {
        this.dialogClose();
      },
    },
  },
  methods: {
    dialogClose() {
      this.pagamentosVisiveis = [];
      this.$emit("dialogClose");
    },
    selecionarPlanos(item) {

      if (item.parcelavel && this.verificarPagamento(item.id)) {
        this.pagamentosVisiveis.pop()
        this.pagamento = item;
        this.dialogPlanos = true;
      }
    },
    addPagamento(id){
      this.pagamentosVisiveis.push(id)
    },
    dialogClosePlanos() {
      this.pagamento = {};
      this.dialogPlanos = false;
    },

    checkboxUpdated(newValue) {
      window.console.log(newValue);
    },
    verificarPagamento(pagamentoId) {
      if (this.pagamentosVisiveis.includes(pagamentoId)) return true;
      else false;
    },
    async loadPagamentos() {
      try {
        if (this.loading) return;
        this.loading = true;

        const response = await this.axios.get(
          `/catalogos/${this.id}/pagamentos`
        );

        this.pagamentos = response.data.formasPagamento;
        this.pagamentosVisiveis = response.data.pagamentosVisiveis;
      } catch (error) {
        this.$store.dispatch("showError", error);
      } finally {
        this.loading = false;
      }
    },
    async salvar() {
      try {
        this.loading = true;

        const response = await this.axios.put(
          `/catalogos/${this.id}/pagamentos`,
          {
            pagamentosVisiveis: this.pagamentosVisiveis,
          }
        );
        if (response.status == 204) {
          //this.fecharTab()
          this.dialogClose();
          this.$store.dispatch(
            "showSuccess",
            "Configurações salvas com sucesso!"
          );
        }
      } catch (error) {
        this.$store.dispatch("showError", error);
      } finally {
        this.loading = false;
      }
    },
  },
  watch: {
    dialog() {
      if (this.dialog) this.loadPagamentos();
    },
  },
};
</script>
